import React from 'react';
import { QStack, QText } from '@qualio/ui-components';

interface LabelValueDisplayProps {
  label: string;
  children: React.ReactNode;
  dataCy?: string;
}

export const LabelValueDisplay: React.FC<LabelValueDisplayProps> = ({ label, children, dataCy }) => {
  return (
    <QStack spacing="1">
      <QText fontWeight="semibold">{label}</QText>
      <QText data-cy={dataCy}>{children}</QText>
    </QStack>
  );
};
